import Menu from "antd/lib/menu";
import { useHistory } from "react-router-dom";
import { RouteConstants } from "../../../router/Constants";
import { useEffect, useState } from "react";
import { HRTabs } from "../../../constants/Constants";
import { checkModuleAuthorization } from "../../../utilities/utilities";

const HeaderMenuComponent = () => {
  const history = useHistory();
  const [selected, setSelected]: any = useState();
  const [openKeys, setOpenKeys] = useState(["evm-dashboard"]);
  const rootSubmenuKeys = ["evm-dashboard", "sub_contract"];

  useEffect(() => {
    setSelected(history.location.pathname);
  }, [history.location.pathname]);

  const onOpenChange = (keys: any) => {
    const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  return (
    <div className="hidden-print header-menu">
      <Menu
        {...(!localStorage.getItem("/")
          ? { openKeys: openKeys, onOpenChange: onOpenChange }
          : null)}
        mode="horizontal"
        selectedKeys={[selected]}
        defaultSelectedKeys={["project"]}
        onSelect={(e: any) => history.replace(e.key.toString())}
        theme="light"
      >
        {checkModuleAuthorization("EVM Dashboard", false, "", "read") && (
          <Menu.Item key={RouteConstants.EVM_DASHBOARD} title="EVM Dashboard">
            EVM Dashboard
          </Menu.Item>
        )}
        {checkModuleAuthorization("Project", false, "", "read") && (
          <Menu.Item key={RouteConstants.PROJECTS} title="Project">
            Project
          </Menu.Item>
        )}
        {checkModuleAuthorization("HR", false, "", "read") && (
          <Menu.Item
            key={"/hr/" + HRTabs.DEPARTMENT.toLowerCase()}
            title="Human Resource"
          >
            Human Resource
          </Menu.Item>
        )}
        {checkModuleAuthorization("Procurement", false, "", "read") && (
          <Menu.Item key={RouteConstants.PROCUREMENT} title="procurement">
            Procurement
          </Menu.Item>
        )}
        {/* {checkModuleAuthorization("Procurement", false, "", "read") && (
          <Menu.Item
            key={RouteConstants.PURCHASE_BUDGET_REQUISITION}
            title="Purchase Budget Requisition"
          >
            Purchase Budget Requisition
          </Menu.Item>
        )} */}
        {checkModuleAuthorization("Inventory", false, "", "read") && (
          <Menu.Item key={RouteConstants.INVENTORY} title="inventory">
            Inventory
          </Menu.Item>
        )}
        {checkModuleAuthorization("Tender", false, "", "read") && (
          <Menu.Item key={RouteConstants.TENDER} title="Tender">
            Tender
          </Menu.Item>
        )}
        {checkModuleAuthorization("Database", false, "", "read") && (
          <Menu.Item key={RouteConstants.DATABASE} title="Database">
            Database
          </Menu.Item>
        )}
        {checkModuleAuthorization("Finance", false, "", "read") && (
          <Menu.Item key={RouteConstants.FINANCE} title="Finance">
            Finance
          </Menu.Item>
        )}
        {checkModuleAuthorization("Site Visit", false, "", "read") && (
          <Menu.Item key={RouteConstants.SITE_VISIT} title="Site Visit">
            Site Visit
          </Menu.Item>
        )}
        {/* {checkModuleAuthorization("Fixed Asset", false, "", "read") && ( */}
        <Menu.Item key={RouteConstants.FIXED_ASSET} title="Fixed Asset">
          Fixed Asset
        </Menu.Item>
        {/* )} */}
        {checkModuleAuthorization("Task", false, "", "read") && (
          <Menu.Item key={RouteConstants.TASK} title="Task">
            Task
          </Menu.Item>
        )}
      </Menu>
    </div>
  );
};
export default HeaderMenuComponent;
